import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const memberApi = {
    getList(year, type) {
        return httpClient.get(API_ROUTES.soccer_list, {
            params: { year, type },
        })
    },

    getInfo(userId, year) {
        return httpClient.get(API_ROUTES.soccer_info, {
            params: { userId, year },
        })
    },

    exportAttendance(months) {
        return httpClient.get(API_ROUTES.soccer_attendance_export, {
            // 使用逗号分隔，Spring 可直接转换为 List<String>。
            params: { months: months.join(',') },
            responseType: 'blob',
        })
    },

    updateInfo(formData) {
        return httpClient.post(API_ROUTES.auth_updateMemberInfo, formData)
    },

    // 管理员编辑指定球员的基础资料与账号状态。
    adminUpdateInfo(payload) {
        return httpClient.post(API_ROUTES.auth_adminUpdateMemberInfo, payload)
    },

    // 本人资料接口由后端按 Authorization 确定目标，不能传 ID 越权修改他人。
    updateOwnInfo(payload) {
        return httpClient.post(API_ROUTES.auth_updateOwnMemberInfo, payload)
    },

    updateStanding(memberId, standingMember) {
        return httpClient.post(API_ROUTES.auth_updateStandingMember, null, {
            params: { memberId, standingMember },
        })
    },

    // 新接口将展示标签、带队资格和队员状态作为三个独立字段提交。
    updateRole(payload) {
        return httpClient.post(API_ROUTES.auth_updateMemberRole, payload)
    },

    create(payload) {
        return httpClient.post(API_ROUTES.member_addMember, payload)
    },

    getGameMembers(params) {
        return httpClient.get(API_ROUTES.member_gameList, { params })
    },
}
